import {
  IonRow,
  IonCol,
  IonGrid,
  IonIcon,
  IonCheckbox,
  IonToggle,
  IonLabel,
  IonText,
} from "@ionic/react";
import { SelectComponent } from "../../../components/shared/SelectComponent";
import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import * as constants from "../../../utils/constants";
import { NewInput } from "../common/OriginInput";
import PickupTime from "../manage-capacity/PickupTime";
import { RadiusRange } from "../RadiusRange/RadiusRange";

const DeliverypData = (props: any) => {
  const {
    destinationError,
    destination,
    destinationCountry,
    destinationPostalCode,
    destinationRadius,
    dropUpdateError,
    defaultValue,
    isDestination,
    useHandler,
    setErrorValue,
    updateLocalCurrentTime,
    dropLocalTime,
    showDate,
    dropStartDate,
    dropEndDate,
    handleError,
    isStatesShow,
    statesList,
    stateError,
    handleStateChange,
    handleCountryChange,
    country,
    countries,
    options,
    resetClick    
  } = props;
  const upDateLocalTime = (time: string) => {
    updateLocalCurrentTime('dropStartDate', time);
  };
  const [checked, setChecked] = useState(true);

  useEffect(() => {
    setChecked(destination === constants.Anywhere);
  }, [destination]);

  const dateChanged = (e: any) => {
    const event = { target: { name: e.target.name === 'fromDate' ? 'dropStartDate' : 'dropEndDate', value: e.target.value } };
    props.handleChange(event);
  }

  return (
    <IonGrid className="delivery-data">
      <IonRow>
        <IonCol size="3" className="search-heading">
          <IonIcon src="assets/icon/destination_icon.svg" />
          <span>Destination</span>
        </IonCol>
        <IonCol size="8">
          <div>
            <div className="state-toggle-div">
              <IonToggle
                mode="ios"
                class="state-toggle"
                checked={isStatesShow}
                data-testid="state-toggler"
                name="showStates"
                onIonChange={props.stateToggle}
              ></IonToggle>
              <IonLabel className="capacity-select-state-label">
                Select States
              </IonLabel>
              <IonText onClick={() => resetClick(false, true)} className={`reset-button ${isStatesShow ? 'reset-button-tab' : ''}`}> Reset</IonText>
            </div>
            <div className="address_field_div">
              {isStatesShow ? (
                <div
                  data-test="state-list-wrapper"
                  className={`states-list-wrapper ${stateError ? "error" : ""}`}
                >
                  <SelectComponent
                    key={`country`}
                    options={countries}
                    placeholder={"Choose the country"}
                    label={""}
                    name={"country"}
                    value={country}
                    handleChange={handleCountryChange}
                  />
                  <IonLabel className="stateLable-web">Select 1 - 3 States/Provinces</IonLabel>
                  {statesList &&
                    statesList.map((state: any, index: number) => (
                      <SelectComponent
                        key={`state${index}`}
                        options={options}
                        placeholder="None"
                        label={""}
                        name={state.name}
                        value={statesList[index] && statesList[index].value}
                        handleChange={handleStateChange}
                      />
                    ))}
                </div>
              ) : (
                <>
                  <div className="destination-input">
                    <div className="textbox-destination" data-testid="destinationInput">
                      <NewInput
                        Error={destinationError}
                        locationValue={false}
                        labelValue=""
                        InputValue={destination}
                        InputName={constants.Destination}
                        handleChange={props.handleChange}
                        keyboardshowHandler={props.keyboardshowHandler}
                        keyboardhideHandler={props.keyboardhideHandler}
                        deFaultValue={defaultValue}
                        isDestination={isDestination}
                        placeholder="Type Destination City"
                        useHandler={useHandler}
                        setErrorValue={setErrorValue}
                        getLocalTime={upDateLocalTime}
                        onFocus={props.onFocus || (() => { })}
                        country={destinationCountry}
                        postalCode={destinationPostalCode}
                      />
                    </div>
                    <div className={`checkbox-destination checkbox-solid ${checked ? "checked" : "not-checked"}`}>
                      <IonCheckbox
                        checked={checked}
                        onClick={(e) => {
                          props.handleCheck(e);
                        }}
                        name="destinationCheck"
                      />{" "}
                      Anywhere
                    </div>
                  </div>
                </>
              )}
              {showDate ? (
                <div className="pick-up-time-alignment">
                  {(
                    <PickupTime
                      pickUpLocalTime={dropLocalTime}
                      handleChange={dateChanged}
                      fromDate={dropStartDate}
                      toDate={dropEndDate}
                      error={dropUpdateError}
                      handleError={handleError}
                      rangeDisable={props.rangeDisable}
                      errorMessage2={props.errorMessage2}
                      errorMessage={props.isSearch ? (props.errorToBeShow || (dropStartDate > dropEndDate ? constants.dropUpdateError : '')) : constants.dropUpdateError}
                    />
                  )}
                </div>
              ) : null}
            </div>
            {!isStatesShow ? (
              <div className="radius-section">
                <RadiusRange
                  labelName="Destination Radius"
                  rangeDisabled={props.rangeDisable}
                  InputValue={destinationRadius}
                  className="pickRadius"
                  name={"destinationRadius"}
                  handleChange={props.handleChange}
                />
              </div>
            ) : null}
          </div>

        </IonCol>

      </IonRow>
    </IonGrid>
  );
};
export default DeliverypData;
